<script setup>
defineProps({
  numberOfSkeletons: {
    type: Number,
    default: 2,
  },
});
</script>
<template>
  <div :class="$style.skeletons">
    <v-skeleton-loader
      v-for="n in numberOfSkeletons"
      :key="n"
      height="250"
      class="skeleton"
    />
  </div>
</template>
<style module>
.skeletons {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
<style scoped>
/** To overwrite skeleton bone height */
.skeleton :deep(.v-skeleton-loader__bone) {
  height: 100%;
}
</style>
